import Vue from 'vue'
import Vuex from 'vuex'
// import users from './modules/users'
// import auth from './modules/auth'
import chat from './modules/chat'
import axios from 'axios'
// import { Notification } from 'element-ui'
import config from '../config.js'
import * as MutationTypes from './mutation-types'
// import dictionaryForMenu from './dictionaryForMenu'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    // auth,
    chat,
    // users,
    // dictionaryForMenu
  },
  state: {
    currentUser: {},
    chatroom: {},
    externalUserId: null,
    countries: [],
    usersAllApplications: [],
    findingCreatingApp: false,
    gotApps: false,
    tempWorkingApplication: {},
    workingApplication: {},
    fetchingNewApp: false,
    neededDocsGr: [],
    neededDocsEn: [],
    neededDocsIds: [],
    neededDocsMandatory: [],
    neededDocsInformation: [],
    neededDocsInformationGr: [],
    neededDocsInformationEng: [],
  },
  actions: {
    SET_USER: function({ commit }, username) {
      commit(MutationTypes.SET_USER, username)
    },
    // todo: use only this call in Login
    GET_APPLICATIONS: function({ commit, state }) {
      if (!state.gotApps) {
        state.findingCreatingApp = true
        return axios
          .get(`${config.BASE_URL}/usersAllApplications`)
          .then(response => {
            state.gotApps = true
            state.findingCreatingApp = false
            if (response.data.success) {
              commit(MutationTypes.SET_APPLICATIONS, response.data.data)
              commit(MutationTypes.SET_APPLICATION, {
                app: response.data.data.workingApplication,
              })
              commit(MutationTypes.SET_CHATROOMS, {
                rooms:
                  response.data.data.workingApplication.applicationChatroom,
              })
            }
          })
          .catch(err => {
            console.log('error' + err)
            state.gotApps = true
            // router.replace('/login')
            state.findingCreatingApp = false
            // if (state.pilotNewEdit !== 'new') { state.backendErrorNotify(err) }
          })
      }
    },
    GET_APPLICATION: function({ commit, state }, { id }) {
      state.fetchingNewApp = true
      let p = axios
        .get(`${config.BASE_URL}/users/uid/applications/${id}`)
        .then(response => {
          commit(MutationTypes.SET_APPLICATION, { app: response.data.data })
          commit(MutationTypes.SET_CHATROOMS, {
            rooms: response.data.data.applicationChatroom,
          })
          state.fetchingNewApp = false
        })
        .catch(err => {
          console.log(err)
          state.fetchingNewApp = false
          let tempMessage = ''
          Object.keys(err.response.data.message).forEach(key => {
            tempMessage += err.response.data.message[key].reduce(
              (acc, cur) => acc.slice(0, -1) + ', ' + cur.slice(0, -1)
            )
          })
          tempMessage = tempMessage + '.'
          this.$notify({
            title: 'Προειδοποίηση',
            message: tempMessage,
            offset: 100,
          })
        })
      return p
    },
  },
  mutations: {
    [MutationTypes.SET_USER](state, username) {
      console.log(username)
      state.currentUser.username = username
    },
    [MutationTypes.SET_APPLICATION](state, { app }) {
      console.log(app)
      state.workingApplication = app
      state.neededDocsGr = []
      state.neededDocsEn = []
      state.neededDocsIds = []
      state.neededDocsMandatory = []
      state.neededDocsInformation = []
      state.neededDocsInformationGr = []
      state.neededDocsInformationEng = []
      app.neededDocuments.forEach(doc => {
        state.neededDocsGr.push(doc.grName)
        state.neededDocsEn.push(doc.engName)
        state.neededDocsIds.push(doc.id)
        state.neededDocsMandatory.push(doc.mandatory)
        state.neededDocsInformation.push(doc.information)
        state.neededDocsInformationGr.push(doc.grInformation)
        state.neededDocsInformationEng.push(doc.engInformation)
      })
    },
    [MutationTypes.SET_APPLICATIONS](state, allApps) {
      console.log(allApps)
      state.tempWorkingApplication = allApps.workingApplication
      allApps.workingApplication.neededDocuments.forEach(doc => {
        state.neededDocsGr.push(doc.grName)
        state.neededDocsEn.push(doc.engName)
        state.neededDocsIds.push(doc.id)
        state.neededDocsInformation.push(doc.information)
        state.neededDocsInformationGr.push(doc.grInformation)
        state.neededDocsInformationEng.push(doc.engInformation)
        state.neededDocsMandatory.push(doc.mandatory)
      })
      state.chatroom = allApps.applicationChatroom
      state.usersAllApplications = allApps.allApplications
      state.countries = allApps.countries
      state.externalUserId = allApps.userId
      state.currentUser.id = allApps.userId
      sessionStorage.setItem(
        'usersAllApplications',
        JSON.stringify(state.usersAllApplications)
      )
    },
  },
  getters: {
    currentUser(state) {
      return state.currentUser
    },
  },
})
